import axios from 'axios';
import appSettings from '../appSettings';

export const insertUserAgreement = async (entity) => {
  const url = appSettings.INSERT_USER_AGREEMENT_URL;
  const res = await axios.post(url, JSON.stringify(entity), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const { status } = res;
  return status;
};
